import { Heading, HeadingProps, StackProps, VStack } from "@chakra-ui/layout";
import React from "react";
import { useLayoutContext } from "../../context/LayoutContext";

interface PageHeadingProps {
  children?: React.ReactNode;
}

const envTitlePrefix =
  APP_ENVIRONMENT !== "" && APP_ENVIRONMENT !== "production"
    ? APP_ENVIRONMENT.charAt(0).toUpperCase() +
      APP_ENVIRONMENT.slice(1).toLowerCase()
    : null;

const Title = ({
  children,
  ...props
}: { children: React.ReactNode } & HeadingProps) => {
  return (
    <Heading as="h1" width="100%" color="white" fontWeight="600" {...props}>
      {envTitlePrefix ? (
        <>
          {envTitlePrefix} {children}
        </>
      ) : (
        children
      )}
    </Heading>
  );
};

export const PageHeading = ({
  children,
  ...props
}: PageHeadingProps & StackProps) => {
  const { isDesktop } = useLayoutContext();

  const paddingProps = isDesktop
    ? { paddingLeft: "100px", paddingRight: "40px" }
    : { paddingLeft: "2", paddingRight: "2" };

  return (
    <VStack
      {...paddingProps}
      spacing="2"
      paddingTop="4"
      paddingBottom="4"
      alignItems="start"
      color="white"
      {...props}
    >
      {children}
    </VStack>
  );
};

PageHeading.Title = Title;
